import { Outlet } from 'react-router-dom';
import { Provider } from 'mobx-react';
import s from './index.module.scss';

import grtStore from '@/store/grtStore';
import grtAi from '@/store/grtAi';
import withRouter from '@/components/withRouter';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import dayjs from 'dayjs';
import { openEgg } from '@/utils/Mobile';
import 'dayjs/locale/zh-cn';
import { Storage } from '@/utils/Storage';
import { useEffect } from 'react';
dayjs.locale('zh-cn');
const WebLayout = () => {
    const onClick = () => {
        let fn = () => {
            grtAi.setEggShow(true);
        };
        openEgg(fn);
    };

    useEffect(() => {
        //todo  临时解决生产的bug，在智能问答版本统一处理其它逻辑
        let pcToken = Storage.get('grtPcToken');
        if (pcToken) {
            Storage.set('Authorization', pcToken);
        }
    }, []);
    return (
        <ConfigProvider locale={zhCN}>
            <Provider store={grtStore}>
                <div onClick={onClick} className={[`grt-box grt-web-box ${s['web-wrap']}`]}>
                    <Outlet></Outlet>
                </div>
            </Provider>
        </ConfigProvider>
    );
};

export default withRouter(WebLayout);
